<template>
  <div class="loading">
    <Bg />

    <!-- logo -->
    <Logo />

    <div :class="['container',{containerMedia:dev}]">

      <!-- loading -->
      <div :class="['loadingbox',{loadingboxMedia:dev}]">

        <!-- loadingBg -->
        <img
          :src="require(`@/assets/img/loading/textBg.png`)"
          class="textBg"
        >
        <!-- 序列帧和文字 -->
        <transition name="load">
          <load-container v-if="!goBtnType" />
        </transition>

      </div>
      <!-- 按钮 -->
      <transition name="goBtn">
        <goBtn v-if="goBtnType" />
      </transition>
    </div>
  </div>
</template>

<script>
// 序列帧和文字
import LoadContainer from "./components/loadContainer";
// 开始按钮
import goBtn from "./components/goBtn";
// logo
import Logo from "../logo";
import Bg from "../bg";
import { loadFont } from "@/tools";
import { mapActions } from "vuex";
export default {
  name: "Loading",
  components: {
    LoadContainer,
    goBtn,
    Logo,
    Bg
  },
  data() {
    return {
      goBtnType: false, // 是否显示btn
      speed: 3000 // 加载时间 5000
    };
  },
  computed: {
    loadFont() {
      return this.$store.state.loadFont;
    },
    dev() {
      return this.$store.state.dev;
    }
  },
  mounted() {
    this.loadingHide();
    loadFont("fz", this.loadFontFn); // 加载字体
  },
  methods: {
    ...mapActions(["loadFontFn"]),
    loadingHide() {
      // setTimeout(() => {
      //   this.goBtnType = true;
      // }, this.speed);
      let val = 50;
      let interval = setInterval(() => {
        this.speed -= val;
        if (this.loadFont && this.speed < 0) {
          this.goBtnType = true;
          clearInterval(interval);
        }
      }, val);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/com.scss";
.load-leave-active,
.goBtn-enter-active {
  transition: opacity 0.8s;
}
// loading 离开动画
.load-leave-to {
  opacity: 0;
}
.load-leave {
  opacity: 1;
}
// 踏足江湖出现动画
.goBtn-enter-to {
  opacity: 1;
}
.goBtn-enter {
  opacity: 0;
}
.loading {
  @include wh(auto, 100%);
}
.bg {
  @include bgObject;
}

.container {
  @include wh(14.9rem, 8rem);
  @include LTRBcenter;
  overflow: hidden;
}
.containerMedia {
  @include wh(100%, 100%);
}

.loadingbox {
  @include wh(1.5rem);
  @include LTRBcenter;
  transform: translate(-52%, -50%);
  @media all and (max-width: 990px) {
    @include wh(1.5rem);
  }
  .textBg {
    @include wh(100%);
  }
}
.loadingboxMedia {
  @include wh(1.5rem);
  transform: translate(-50%, -50%) rotate(90deg);
}
</style>


